<template>
  <div class="post-body">
    <p class="post-body__content"
       v-html="post.text">
    </p>
    <post-modal-counters :post="post"/>
    <div class="post-body__show-more">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import PostModalCounters from './postModalCounters.vue';

export default {
  name: 'postBody',
  props: {
    post: {
      type: Object
    },
  },
  components: {
    PostModalCounters
  }
};
</script>

<style lang="stylus">
.post
  &-body
    width 100%
    line-height 1.5em
    &__show-more
      display flex
      justify-content space-between
      font-family: "Oswald", "Arial", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 23px;
      color: #55626F;
      cursor pointer
</style>
